import { Flex, Text, VStack } from "@chakra-ui/react";
import React from "react";
import IssbContainer from "../../IssbContainer";
import AuditInfo from "./AuditInfo";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AButton } from "../../../../components/A";
import { FaArrowLeft } from "react-icons/fa";
import { routes } from "../../../../config";

const CompletedAuditInfo = () => {
  const [searchParams] = useSearchParams();
  const auditId = searchParams.get("id");

  const { audits } = useSelector((state) => state.issbRound || {});

  const auditData = audits?.find((audit) => audit.id === auditId); // Use `find` for a single match
  console.log("auditata", auditData);

  return (
    <IssbContainer margin="20%">
      <VStack align="start" spacing={2}>
        <Flex align="center">
          <AButton leftIcon={<FaArrowLeft />} variant="link" color="limeShade.600" href={routes.issbAuditControl}>
            <Text as="span" color="whiteShade.600">
              Back
            </Text>
          </AButton>
        </Flex>
        <Text fontSize="heading.2xl" fontWeight="bold" color="darkTeal">
          {auditData?.stageName}
        </Text>
        <Text fontSize="body.m" color="gray.500">
          From here you can initiate an audit and manage its settings.
        </Text>
      </VStack>
      <AuditInfo auditData={auditData} />
    </IssbContainer>
  );
};

export default CompletedAuditInfo;
